// extracted by mini-css-extract-plugin
module.exports = {"Profile":"Profile_Profile__3HF8E","Image":"Profile_Image__1PJ0L"};